import React, { Component } from 'react'

export default class Footer extends Component {
    render() {
        return (
            <div className="Footer">
               TODO
                Footer Footer Footer Footer Footer Footer Footer Footer Footer 
            </div>
        )
    }
}
